import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";
import { Chip, Link, Stack } from "@mui/material";
import AttachmentItem from "components/Attachments/AttachmentItem";
import { getOriginalFileName } from "utils/utils";

const fileChip = (url, idx) => (
  <Chip
    component={Link}
    href={url}
    target="_blank"
    rel="noopener noreferrer"
    clickable
    size="small"
    icon={<AttachFileOutlinedIcon />}
    label={getOriginalFileName(url) || `File ${idx + 1}`}
    variant="outlined"
  />
);

/**
 * A payment's receipts: images preview inline and open large on click, other files are chips that
 * open in a new tab. Renders nothing when there are none.
 */
const PaymentReceiptChips = ({ urls = [], sx = { mt: 1 } }) =>
  urls.length === 0 ? null : (
    <Stack direction="row" flexWrap="wrap" gap={0.5} useFlexGap sx={sx}>
      {urls.map((url, idx) => (
        <AttachmentItem
          key={`${idx}:${url}`}
          url={url}
          renderFile={(fileUrl) => fileChip(fileUrl, idx)}
        />
      ))}
    </Stack>
  );

export default PaymentReceiptChips;
